<template>
  <div>
    <v-tooltip bottom :open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn dark icon v-bind="attrs" v-on="on" @click="mudarEstadoDialog()">
          <v-icon small>mdi-bell-off</v-icon>
        </v-btn>
      </template>

      <span>Silenciar todos os produtos do fornecedor</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'SilenciarFornecedor',
  components: {
  },
  computed: {
    DIALOG_SILENCIAR_PRODUTO: {
      get: function() {
        return this.$store.state.app.dialogSilenciarProduto;
      },
      set: function(valor) {
        this.$store.commit("app/setDialogSilenciarProduto", valor);
      }
    }
  },
  methods: {
    mudarEstadoDialog() {
      this.DIALOG_SILENCIAR_PRODUTO = !this.DIALOG_SILENCIAR_PRODUTO;
      this.definirPayloadSilenciarFornecedor();
    },
    definirPayloadSilenciarFornecedor() {
      if (!this.DIALOG_SILENCIAR_PRODUTO) return;

      const obj = {
        silenciar_todo_fornecedor: true,
        produtos: []
      }
      this.$store.commit("notificacaoProdutoSilenciado/setProdutoSilenciadoEditar", obj);
    }
  }
}
</script>

<style>

</style>
